import { EnvConfig } from "../config/api";
import { getAuthClient, AuthClientInstance } from "@trumpf/ux.utils";

const authClientServiceCalls: AuthClientInstance = getAuthClient();

export class ApiClient {
    private config: EnvConfig;
    private tbdbToken: string | null = null;

    constructor(config: EnvConfig) {
        this.config = config;
    }

    /**
     * Request function to send an authenticated POST request to the PublicAPI
     * @param path path of the API endpoint without baseUrl
     * @param body object to send to the API (token is added automatically)
     * @param mockResponse response to return when using mock data
     * @returns Promise with the response of the API
     */
    async request<T>(path: string, body?: object, mockResponse?: T): Promise<T> {
        if (this.config.useMockData) {
            return this.mockRequest<T>(mockResponse as T);
        }

        if (authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        if (!this.tbdbToken) {
            return Promise.reject("No TBDB token");
        }
        return fetch(`${this.config.baseUrl}${path}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ...body,
                token: this.tbdbToken
            })
        }).then((response) => {
            if (response.status === 401) {
                authClientServiceCalls.deleteAccessToken();
                return Promise.reject("Unauthorized");
            }
            return response.json();
        });
    }

    private async mockRequest<T>(mockResponse: T): Promise<T> {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockResponse);
            }, 1000);
        });
    }

    async requestTbdbToken(): Promise<string> {
        if (this.config.useMockData) {
            return this.mockRequest<string>("mockToken");
        }
        const token = authClientServiceCalls.getAccessToken();
        return fetch(`${this.config.baseUrl}/user/createticket`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                clientType: this.config.publicAPIClientType,
                apiVersion: this.config.publicAPIVersion
            })
        })
            .then((response) => {
                if (response.status === 401) {
                    return Promise.reject("Unauthorized");
                }
                return response.json();
            })
            .then((data) => {
                this.tbdbToken = data.token;
                return data.token;
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.error("Error while fetching tbdb token", error);
                return null;
            });
    }
}
